// extracted by css-extract-rspack-plugin
export default {"hidden":"_fcc0b0a3"};